export default __webpack_public_path__ + "static/media/vinyls.b94d042a.jpg";